// import { courseDetails as BAGlobalBusinessandEntrepreneurshipwithFoundationYear } from "./courseDetails/BAGlobalBusinessandEntrepreneurshipwithFoundationYear";
// import { courseDetails as BScBusinessandTourismManagement } from "./courseDetails/BScBusinessandTourismManagement";
// import { courseDetails as BAGlobalBusinessManagementwithFoundationYear } from "./courseDetails/BAGlobalBusinessManagementwithFoundationYear";
// import { courseDetails as BScProjectManagementwithFoundationYear } from "./courseDetails/BScProjectManagementwithFoundationYear";
// import { courseDetails as BScAppliedBusinessPsychologywithFoundationYear } from "./courseDetails/BScAppliedBusinessPsychologywithFoundationYear";
// import { courseDetails as HNDinBusiness } from "./courseDetails/HNDinBusiness";
// import { courseDetails as mscGlobalBusiness } from "./courseDetails/MScGlobalBusiness";
// import { courseDetails as BScHealthWellbeingandSocialCarewithFoundationYear } from "./courseDetails/BScHealthWellbeingandSocialCarewithFoundationYear";
// import { courseDetails as HNDInHealthandSocialCarePractice } from "./courseDetails/HNDInHealthandSocialCarePractice";
// import { courseDetails as BScComputingwithFoundationYear } from "./courseDetails/BScComputingwithFoundationYear";
// import { courseDetails as HNDinDigitalTechnologiesforEnglandCyberSecurity } from "./courseDetails/HNDinDigitalTechnologiesforEnglandCyberSecurity";
// import { courseDetails as BScConstructionManagementwithFoundationYear } from "./courseDetails/BScConstructionManagementwithFoundationYear";
// import { courseDetails as HNDinConstructionManagementforEngland } from "./courseDetails/HNDinConstructionManagementforEngland";
// import { courseDetails as BScAccountingandFinancialManagement } from "./courseDetails/BScAccountingandFinancialManagement";
// import { courseDetails as BABusinessandManagement } from "./courseDetails/BABusinessandManagement";
// import { courseDetails as BScHealthWellbeingandSocialCare } from "./courseDetails/BScHealthWellbeingandSocialCare";
// import { courseDetails as BScConstructionManagement } from "./courseDetails/BScConstructionManagement";
// import { courseDetails as MScProjectManagement } from "./courseDetails/MScProjectManagement";
// import { courseDetails as BScPsychologywithCounsellingwithFoundationYear } from "./courseDetails/BScPsychologywithCounsellingwithFoundationYear";
// import { courseDetails as MScCounsellingandPsychotherapy } from "./courseDetails/MScCounsellingandPsychotherapy";



// export const courseDataMap = {
//   "bsc-hons-global-business-and-entrepreneurship-with-foundation-year": BAGlobalBusinessandEntrepreneurshipwithFoundationYear, 
//   "bsc-business-and-tourism-management": BScBusinessandTourismManagement,
//   "ba-hons-global-business-with-foundation-year": BAGlobalBusinessManagementwithFoundationYear,
//   "bsc-project-management-with-foundation-year": BScProjectManagementwithFoundationYear,
//   "bsc-applied-business-psychology-with-foundation-year": BScAppliedBusinessPsychologywithFoundationYear,
//   6: HNDinBusiness,
//   7: mscGlobalBusiness,
//   8: BScHealthWellbeingandSocialCarewithFoundationYear,
//   9: HNDInHealthandSocialCarePractice,
//   10: BScComputingwithFoundationYear,
//   11: HNDinDigitalTechnologiesforEnglandCyberSecurity,
//   12: BScConstructionManagementwithFoundationYear,
//   13: HNDinConstructionManagementforEngland,
//   "bsc-accounting-and-financial-management": BScAccountingandFinancialManagement,
//   "bsc-hons-business-and-management": BABusinessandManagement,
//   16: BScHealthWellbeingandSocialCare,
//   17: BScConstructionManagement,
//   18: MScProjectManagement,
//   19: BScPsychologywithCounsellingwithFoundationYear,
//   20: MScCounsellingandPsychotherapy
// };

// Mapping of slug keys to their specific API endpoints
const ENDPOINT_MAP = {
  "ba-hons-business-and-entrepreneurship": "https://api.npoint.io/75d7186287494ffb85a2",
  "bsc-hons-business-and-tourism-management": "https://api.npoint.io/46f77842de71e294e80f",
  "ba-hons-business": "https://api.npoint.io/06baa3caf64167fd35c4",
  "bsc-hons-project-management-with-foundation-year": "https://api.npoint.io/1df954fefff4adc39c99",
  "bsc-hons-applied-business-psychology-with-foundation-year": "https://api.npoint.io/982191ed2cb4b1df81fc",
  "hnd-in-business": "https://api.npoint.io/1eb7ac3c5b5b92778b59",
  "bsc-accounting-and-financial-management": "https://api.npoint.io/7e336935a7f1db22e3f0",
  "bsc-hons-computing-with-foundation-year": "https://api.npoint.io/0272dde2f6bb8c9b55b5",
  "bsc-hons-health-wellbeing-and-social-care-with-foundation-year": "https://api.npoint.io/6914b69c62b0dcc2658f",
  "bsc-hons-construction-management-with-foundation-year": "https://api.npoint.io/17c9666372a893b4e42a",
  "hnd-in-digital-technologies-for-england": "https://api.npoint.io/765b27b22baa8b4429d1",
  "msc-business": "https://api.npoint.io/b25a4fdfcf9be4091265",
  "hnd-in-health-and-social-care-practice": "https://api.npoint.io/91e21797ec49ac3f7571",
  "msc-project-management": "https://api.npoint.io/e99cc18556b74250e51e",
  "msc-counselling-and-psychotherapy": "https://api.npoint.io/3b463cd82c04d10f6d41",
  "hnd-in-construction-management-for-england": "https://api.npoint.io/0820e5010d4b726c7a55",
  "ba-hons-business-and-management": "https://api.npoint.io/7817c1ea51d497d48d59",
  "bsc-hons-health-wellbeing-and-social-care-level-6-direct-entry": "https://api.npoint.io/ebec288881ff1f2bfd9f",
  "bsc-hons-construction-management-level-6-top-up": "https://api.npoint.io/54741340691a5425c002",
  "bsc-hons-psychology-with-counselling-with-foundation-year": "https://api.npoint.io/b33352bc6fff4e3a1679"
};

export const getCourseData = async (slug) => {
  try {
    const endpoint = ENDPOINT_MAP[slug] || ENDPOINT_MAP["default"];

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error("Failed to fetch");

    const data = await response.json();
    
    if (data && data.courseDetails) {
      return data.courseDetails;
    }

    return null;
  } catch (error) {
    console.error("Mapping/Fetch Error:", error);
    return null;
  }
};